import { useTenantAuth } from '../contexts/TenantAuthContext';

export const useTenantType = () => {
  const { tenant } = useTenantAuth();

  const tenantType = tenant?.tenant_type || 'product'; // Default to product if not specified

  return {
    tenantType,
    isProductTenant: tenantType === 'product',
    isServiceTenant: tenantType === 'service',
  };
};

export const toTitleCase = (str: string | null | undefined): string => {
  if (!str) {
    return '';
  }

  return str.toLowerCase().split(' ').map((word: string) => {
    if (word.length === 0) return word;

    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join(' ');
};